export default __webpack_public_path__ + "media/src/features/home-page-location-filter-widget/assets/magnifyingGlass-896b1c3bc76168c0d942ed76f693b4d4.svg";